// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"c7f4d70a","666":"8f69f5a0"}[chunkId] + ".chunk.js";
};